/* Lúmina — GlorySmile V34 — scripts */
(function () {
  "use strict";

  function initReveal() {
    var els = document.querySelectorAll(".mt-reveal");
    if (!els.length) return;
    if (!("IntersectionObserver" in window)) {
      els.forEach(function (el) { el.classList.add("mt-visible"); });
      return;
    }
    var obs = new IntersectionObserver(
      function (entries) {
        entries.forEach(function (entry, i) {
          if (entry.isIntersecting) {
            var el = entry.target;
            var delay = parseInt(el.getAttribute("data-mt-delay") || "0", 10);
            setTimeout(function () { el.classList.add("mt-visible"); }, delay);
            obs.unobserve(el);
          }
        });
      },
      { threshold: 0.12, rootMargin: "0px 0px -40px 0px" }
    );
    els.forEach(function (el, i) {
      if (!el.hasAttribute("data-mt-delay")) {
        el.setAttribute("data-mt-delay", String((i % 4) * 90));
      }
      obs.observe(el);
    });
  }

  function initFaq() {
    var items = document.querySelectorAll("[data-mt-faq-item]");
    if (!items.length) return;
    items.forEach(function (item) {
      var btn = item.querySelector("[data-mt-faq-trigger]");
      var panel = item.querySelector("[data-mt-faq-panel]");
      if (!btn || !panel) return;
      btn.addEventListener("click", function () {
        var isOpen = item.classList.contains("mt-faq-item--open");
        items.forEach(function (other) {
          other.classList.remove("mt-faq-item--open");
          var p = other.querySelector("[data-mt-faq-panel]");
          if (p) p.style.maxHeight = null;
          var b = other.querySelector("[data-mt-faq-trigger]");
          if (b) b.setAttribute("aria-expanded", "false");
        });
        if (!isOpen) {
          item.classList.add("mt-faq-item--open");
          panel.style.maxHeight = panel.scrollHeight + "px";
          btn.setAttribute("aria-expanded", "true");
        }
      });
    });
  }

  function initTestimonialCarousel() {
    var track = document.querySelector("[data-mt-testimonial-track]");
    if (!track) return;
    var wrap = track.closest("[data-mt-testimonial-wrap]");
    if (wrap && wrap.getAttribute("data-mt-autoplay") === "true" && !window.matchMedia("(prefers-reduced-motion: reduce)").matches) {
      track.classList.add("mt-testimonials__track--auto");
    }
    var prev = document.querySelector("[data-mt-testimonial-prev]");
    var next = document.querySelector("[data-mt-testimonial-next]");
    function scrollByCard(dir) {
      var card = track.querySelector(".mt-testimonial-card");
      if (!card) return;
      track.classList.remove("mt-testimonials__track--auto");
      var amount = card.getBoundingClientRect().width + 20;
      track.scrollBy({ left: dir * amount, behavior: "smooth" });
    }
    if (prev) prev.addEventListener("click", function () { scrollByCard(-1); });
    if (next) next.addEventListener("click", function () { scrollByCard(1); });
  }

  function initBeforeAfter() {
    var widgets = document.querySelectorAll("[data-mt-ba]");
    widgets.forEach(function (widget) {
      var handle = widget.querySelector("[data-mt-ba-handle]");
      var afterWrap = widget.querySelector("[data-mt-ba-after]");
      if (!handle || !afterWrap) return;
      var dragging = false;

      function setPos(clientX) {
        var rect = widget.getBoundingClientRect();
        var x = Math.min(Math.max(clientX - rect.left, 0), rect.width);
        var pct = (x / rect.width) * 100;
        afterWrap.style.clipPath = "inset(0 " + (100 - pct) + "% 0 0)";
        handle.style.left = pct + "%";
      }

      function onMove(e) {
        if (!dragging) return;
        var clientX = e.touches ? e.touches[0].clientX : e.clientX;
        setPos(clientX);
      }
      function onUp() { dragging = false; }

      handle.addEventListener("mousedown", function () { dragging = true; });
      handle.addEventListener("touchstart", function () { dragging = true; }, { passive: true });
      window.addEventListener("mousemove", onMove);
      window.addEventListener("touchmove", onMove, { passive: true });
      window.addEventListener("mouseup", onUp);
      window.addEventListener("touchend", onUp);
      widget.addEventListener("click", function (e) {
        if (e.target === handle) return;
        setPos(e.clientX);
      });
    });
  }

  function initCountUp() {
    var els = document.querySelectorAll("[data-mt-countup]");
    if (!els.length || !("IntersectionObserver" in window)) return;
    var obs = new IntersectionObserver(function (entries) {
      entries.forEach(function (entry) {
        if (!entry.isIntersecting) return;
        var el = entry.target;
        var target = parseFloat(el.getAttribute("data-mt-countup"));
        var suffix = el.getAttribute("data-mt-suffix") || "";
        var dur = 1400;
        var start = null;
        function step(ts) {
          if (!start) start = ts;
          var progress = Math.min((ts - start) / dur, 1);
          var eased = 1 - Math.pow(1 - progress, 3);
          el.textContent = Math.round(target * eased) + suffix;
          if (progress < 1) requestAnimationFrame(step);
        }
        requestAnimationFrame(step);
        obs.unobserve(el);
      });
    }, { threshold: 0.5 });
    els.forEach(function (el) { obs.observe(el); });
  }

  /* ===== Galería: carrusel 3D con barras tipo historias =====
     La foto activa va al centro y las vecinas asoman a los lados. Avanza
     sola mientras está en pantalla; si el cliente toca algo se pausa y
     retoma sola después de unos segundos sin tocar. El video arranca en
     silencio y un botón le pone sonido (con sonido ya no se pasa sola). */
  function initGallery() {
    var reducir = window.matchMedia("(prefers-reduced-motion: reduce)").matches;
    var hover = window.matchMedia("(hover: hover) and (pointer: fine)").matches;
    var ESPERA = 4000;
    var RETOMAR = 7000;

    document.querySelectorAll("[data-mt-gallery]").forEach(function (gallery) {
      var main = gallery.querySelector("[data-mt-gallery-main]");
      var slides = [].slice.call(gallery.querySelectorAll("[data-mt-gallery-slide]"));
      var barras = [].slice.call(gallery.querySelectorAll("[data-mt-gallery-thumb]"));
      var glows = [].slice.call(gallery.querySelectorAll("[data-mt-gallery-glow]"));
      var actualTxt = gallery.querySelector("[data-mt-gallery-actual]");
      var total = slides.length;
      if (!total) return;

      var idx = 0;
      var enPantalla = false;
      var pausadoHasta = 0;
      var conSonido = false;
      var timer = null, retomar = null;

      function video(i) { return slides[i] && slides[i].querySelector("video"); }
      function puedeAvanzar() { return !reducir && total > 1 && enPantalla && !conSonido && Date.now() >= pausadoHasta; }

      function pintarBarras() {
        barras.forEach(function (b, n) {
          var i = b.querySelector("i");
          b.classList.toggle("mt-gallery__thumb--active", n === idx);
          b.classList.toggle("mt-gallery__barra--llena", n < idx);
          b.classList.remove("mt-gallery__barra--corriendo");
          if (i) { i.style.transition = "none"; i.style.width = n < idx ? "100%" : "0"; }
        });
      }

      function colocar() {
        slides.forEach(function (s, n) {
          var d = n - idx;
          if (d > total / 2) d -= total;
          if (d < -total / 2) d += total;
          s.setAttribute("data-pos", Math.abs(d) > 1 ? (d > 0 ? "2" : "-2") : String(d));
          s.classList.toggle("mt-gallery__slide--active", d === 0);
          if (d !== 0) { var v = s.querySelector("video"); if (v) v.pause(); }
        });
        glows.forEach(function (g, n) { g.classList.toggle("mt-gallery__glow-capa--activa", n === idx); });
        if (actualTxt) actualTxt.textContent = String(idx + 1);
        pintarBarras();
      }

      function programar() {
        clearTimeout(timer);
        var barra = barras[idx];
        var v = video(idx);
        if (v) {
          /* El video corre siempre que esté activo y en pantalla; la barra sigue su avance */
          if (enPantalla) { var p = v.play(); if (p && p.catch) p.catch(function () {}); }
          return;
        }
        if (!puedeAvanzar()) return;
        if (barra) {
          var i = barra.querySelector("i");
          if (i) { void i.offsetWidth; i.style.transition = "width " + ESPERA + "ms linear"; i.style.width = "100%"; }
        }
        timer = setTimeout(function () { ir(idx + 1); }, ESPERA);
      }

      function ir(i) {
        idx = (i + total) % total;
        quitarZoom();
        if (conSonido) { conSonido = false; }
        slides.forEach(function (s) {
          var v = s.querySelector("video");
          if (v) { v.muted = true; s.classList.remove("mt-gallery__slide--sonido"); var b = s.querySelector("[data-mt-gallery-sonido]"); if (b) b.innerHTML = "🔇 <span>Tocá para escuchar</span>"; }
        });
        colocar();
        programar();
      }

      /* El cliente tocó algo: pausa y retoma sola más tarde */
      function pausa() {
        pausadoHasta = Date.now() + RETOMAR;
        clearTimeout(retomar);
        retomar = setTimeout(programar, RETOMAR + 50);
      }
      function irPorCliente(i) { pausa(); ir(i); clearTimeout(timer); }

      barras.forEach(function (b, n) { b.addEventListener("click", function () { irPorCliente(n); }); });
      var prev = gallery.querySelector("[data-mt-gallery-prev]");
      var next = gallery.querySelector("[data-mt-gallery-next]");
      if (prev) prev.addEventListener("click", function () { irPorCliente(idx - 1); });
      if (next) next.addEventListener("click", function () { irPorCliente(idx + 1); });

      /* Tocar una foto de los lados la trae al centro */
      slides.forEach(function (s, n) {
        s.addEventListener("click", function (e) {
          if (s.getAttribute("data-pos") !== "0") { e.preventDefault(); irPorCliente(n); }
        });
      });

      /* Video: la barra sigue su avance; al terminar pasa a la siguiente */
      slides.forEach(function (s, n) {
        var v = s.querySelector("video");
        if (!v) return;
        v.addEventListener("timeupdate", function () {
          if (n !== idx || !v.duration) return;
          var i = barras[n] && barras[n].querySelector("i");
          if (i) { i.style.transition = "width 0.25s linear"; i.style.width = (v.currentTime / v.duration * 100) + "%"; }
        });
        v.addEventListener("ended", function () {
          if (n !== idx) return;
          if (conSonido || Date.now() < pausadoHasta) { v.currentTime = 0; return; }
          ir(idx + 1);
        });
        v.addEventListener("click", function () {
          if (s.getAttribute("data-pos") !== "0") return;
          if (v.paused) { var p = v.play(); if (p && p.catch) p.catch(function () {}); } else { v.pause(); pausa(); }
        });
        var sonido = s.querySelector("[data-mt-gallery-sonido]");
        if (sonido) sonido.addEventListener("click", function (e) {
          e.stopPropagation();
          conSonido = v.muted;
          v.muted = !v.muted;
          s.classList.toggle("mt-gallery__slide--sonido", !v.muted);
          sonido.innerHTML = v.muted ? "🔇 <span>Tocá para escuchar</span>" : "🔊 <span>Sonido activado</span>";
          if (!v.muted) { clearTimeout(timer); if (v.ended) v.currentTime = 0; var p = v.play(); if (p && p.catch) p.catch(function () {}); }
        });
      });

      function quitarZoom() {}

      /* Profundidad 3D: la foto del centro se inclina siguiendo el mouse,
         con un reflejo de luz. En celular se mece sola (lo hace el CSS). */
      if (hover && !reducir) {
        main.addEventListener("mousemove", function (e) {
          var s = slides[idx];
          var r = s.getBoundingClientRect();
          var px = (e.clientX - r.left) / r.width, py = (e.clientY - r.top) / r.height;
          if (px < -0.2 || px > 1.2 || py < -0.2 || py > 1.2) return;
          s.style.setProperty("--mt-ry", ((px - 0.5) * 16).toFixed(2) + "deg");
          s.style.setProperty("--mt-rx", ((0.5 - py) * 12).toFixed(2) + "deg");
          s.style.setProperty("--mt-luz-x", (px * 100).toFixed(1) + "%");
          s.style.setProperty("--mt-luz-y", (py * 100).toFixed(1) + "%");
          s.classList.add("mt-gallery__slide--inclinada");
        });
        main.addEventListener("mouseleave", function () {
          slides.forEach(function (s) {
            s.classList.remove("mt-gallery__slide--inclinada");
            s.style.removeProperty("--mt-ry"); s.style.removeProperty("--mt-rx");
          });
        });
      }

      /* Deslizar con el dedo */
      var x0 = null, y0 = null;
      main.addEventListener("touchstart", function (e) {
        if (e.target.closest("button")) { x0 = null; return; }
        x0 = e.touches[0].clientX; y0 = e.touches[0].clientY;
      }, { passive: true });
      main.addEventListener("touchend", function (e) {
        if (x0 === null) return;
        var t = e.changedTouches[0];
        var dx = t.clientX - x0, dy = t.clientY - y0;
        if (Math.abs(dx) > 40 && Math.abs(dx) > Math.abs(dy)) irPorCliente(dx < 0 ? idx + 1 : idx - 1);
        x0 = null;
      });

      colocar();
      gallery.classList.add("mt-gallery--lista");

      if (!("IntersectionObserver" in window)) { enPantalla = true; programar(); return; }
      new IntersectionObserver(function (entries) {
        enPantalla = entries[0].isIntersecting;
        if (enPantalla) programar();
        else { clearTimeout(timer); var v = video(idx); if (v) v.pause(); pintarBarras(); }
      }, { threshold: 0.5 }).observe(main);
    });
  }

  /* Acompañamiento (recibís → guía → seguimiento → resultados): los pasos se
     encienden en cadena en bucle, y cuando en el chat aparece el mensaje que
     corresponde a un paso, se puede encender ese paso con la función que
     devuelve. */
  function initGuia(root) {
    var guia = root.querySelector("[data-mt-wa-guia]");
    if (!guia) return function () {};
    var pasos = [].slice.call(guia.querySelectorAll("[data-mt-wa-paso-item]"));
    var reducir = window.matchMedia("(prefers-reduced-motion: reduce)").matches;
    var ciclo = null, pausaHasta = 0, i = 0;

    function marcar(n) {
      pasos.forEach(function (p, k) {
        p.classList.toggle("mt-wa__paso--hecho", k < n);
        p.classList.toggle("mt-wa__paso--activo", k === n - 1);
      });
      guia.style.setProperty("--mt-guia-avance", pasos.length > 1 ? ((n - 1) / (pasos.length - 1)) : 1);
    }
    if (reducir || !pasos.length) { marcar(pasos.length); return function () {}; }

    function tic() {
      if (Date.now() < pausaHasta) return;
      i = i >= pasos.length + 2 ? 1 : i + 1; /* dos tiempos de pausa con todo encendido */
      marcar(Math.min(i, pasos.length));
    }
    if ("IntersectionObserver" in window) {
      new IntersectionObserver(function (entries) {
        if (entries[0].isIntersecting) { if (!ciclo) { tic(); ciclo = setInterval(tic, 1400); } }
        else { clearInterval(ciclo); ciclo = null; }
      }, { threshold: 0.3 }).observe(guia);
    } else {
      marcar(pasos.length);
    }

    return function (n) {
      n = parseInt(n, 10);
      if (!n || n > pasos.length) return;
      pausaHasta = Date.now() + 4500;
      i = n;
      marcar(n);
    };
  }

  function initWhatsapp() {
    document.querySelectorAll("[data-mt-wa]").forEach(function (root) {
      initGuia(root);
      var chats = [].slice.call(root.querySelectorAll("[data-mt-wa-chat]"));
      var tabs = [].slice.call(root.querySelectorAll("[data-mt-wa-tab]"));
      var phone = root.querySelector("[data-mt-wa-phone]");
      var reducir = window.matchMedia("(prefers-reduced-motion: reduce)").matches;
      if (!chats.length || !phone) return;
      var actual = 0;

      /* Cambio instantáneo de captura: nada de esperas */
      function mostrar(n) {
        actual = (n + chats.length) % chats.length;
        chats.forEach(function (c, k) { c.classList.toggle("mt-wa__chat--activo", k === actual); });
        tabs.forEach(function (t, k) {
          t.classList.toggle("mt-wa__tab--activa", k === actual);
          t.setAttribute("aria-selected", k === actual ? "true" : "false");
        });
      }

      tabs.forEach(function (tab, n) { tab.addEventListener("click", function () { mostrar(n); }); });
      root.querySelectorAll("[data-mt-wa-ir]").forEach(function (b) {
        b.addEventListener("click", function () {
          mostrar(parseInt(b.getAttribute("data-mt-wa-ir"), 10) || 0);
          if (window.innerWidth < 900) phone.scrollIntoView({ behavior: reducir ? "auto" : "smooth", block: "center" });
        });
      });

      /* Deslizar el teléfono cambia de captura */
      var x0 = null, y0 = null;
      phone.addEventListener("touchstart", function (e) { x0 = e.touches[0].clientX; y0 = e.touches[0].clientY; }, { passive: true });
      phone.addEventListener("touchend", function (e) {
        if (x0 === null || chats.length < 2) return;
        var dx = e.changedTouches[0].clientX - x0, dy = e.changedTouches[0].clientY - y0;
        if (Math.abs(dx) > 50 && Math.abs(dx) > Math.abs(dy)) mostrar(actual + (dx < 0 ? 1 : -1));
        x0 = null;
      });

      /* El botón lleva a elegir paquete, igual que el resto de la página */
      var comprar = root.querySelector("[data-mt-wa-comprar]");
      if (comprar) comprar.addEventListener("click", function () {
        var destino = document.querySelector("[data-mt-purchase-root]");
        if (destino) destino.scrollIntoView({ behavior: reducir ? "auto" : "smooth", block: "start" });
      });
    });
  }

  /* ===== Cobertura: el mapa y la lista se iluminan juntos ===== */
  function initCobertura() {
    var mapa = document.querySelector(".mt-cobertura");
    if (!mapa) return;
    var provs = mapa.querySelectorAll(".mt-cobertura__prov");
    var chips = mapa.querySelectorAll(".mt-cobertura__lista li");

    function marcar(nombre, activo) {
      provs.forEach(function (p) {
        if (p.getAttribute("data-prov") === nombre) p.classList.toggle("mt-activa", activo);
      });
      chips.forEach(function (c) {
        if (c.getAttribute("data-prov") === nombre) c.classList.toggle("mt-activa", activo);
      });
    }

    [].concat([].slice.call(provs), [].slice.call(chips)).forEach(function (el) {
      var nombre = el.getAttribute("data-prov");
      el.addEventListener("mouseenter", function () { marcar(nombre, true); });
      el.addEventListener("mouseleave", function () { marcar(nombre, false); });
      el.addEventListener("touchstart", function () { marcar(nombre, true); }, { passive: true });
      el.addEventListener("touchend", function () {
        setTimeout(function () { marcar(nombre, false); }, 700);
      });
    });
  }

  /* ===== Costa Rica: selects en cascada ===== */
  function initCrLocation() {
    var provSel = document.querySelector("[data-mt-provincia]");
    if (!provSel || !window.MT_CR_DATA) return;
    var cantonSel = document.querySelector("[data-mt-canton]");
    var distritoSel = document.querySelector("[data-mt-distrito]");

    function fillSelect(select, items, placeholder) {
      select.innerHTML = "";
      var opt0 = document.createElement("option");
      opt0.value = "";
      opt0.textContent = placeholder;
      select.appendChild(opt0);
      items.forEach(function (label) {
        var opt = document.createElement("option");
        opt.value = label;
        opt.textContent = label;
        select.appendChild(opt);
      });
      select.disabled = items.length === 0;
    }

    fillSelect(provSel, window.MT_CR_DATA.map(function (p) { return p.n; }), "Selecciona tu provincia");
    fillSelect(cantonSel, [], "Selecciona primero tu provincia");
    fillSelect(distritoSel, [], "Selecciona primero tu cantón");

    provSel.addEventListener("change", function () {
      var prov = window.MT_CR_DATA.find(function (p) { return p.n === provSel.value; });
      fillSelect(cantonSel, prov ? prov.c.map(function (c) { return c.n; }) : [], "Selecciona tu cantón");
      fillSelect(distritoSel, [], "Selecciona primero tu cantón");
    });

    cantonSel.addEventListener("change", function () {
      var prov = window.MT_CR_DATA.find(function (p) { return p.n === provSel.value; });
      var canton = prov && prov.c.find(function (c) { return c.n === cantonSel.value; });
      fillSelect(distritoSel, canton ? canton.d : [], "Selecciona tu distrito");
    });
  }

  /* ===== Opciones de compra + resumen + envío a checkout ===== */
  function initPurchaseFlow() {
    var root = document.querySelector("[data-mt-purchase-root]");
    if (!root) return;

    var options = root.querySelectorAll("[data-mt-option]");
    var summaryQty = document.querySelector("[data-mt-summary-qty]");
    var summaryTotal = document.querySelector("[data-mt-summary-total]");
    var stickyPrice = document.querySelector("[data-mt-sticky-price]");
    var hiddenVariant = document.querySelector("[data-mt-selected-variant]");
    var hiddenLabel = document.querySelector("[data-mt-selected-label]");

    function selectOption(opt) {
      options.forEach(function (o) { o.classList.remove("mt-option--selected"); });
      opt.classList.add("mt-option--selected");
      var price = opt.getAttribute("data-mt-price-fmt");
      var qty = opt.getAttribute("data-mt-qty");
      var label = opt.getAttribute("data-mt-label");
      var variantId = opt.getAttribute("data-mt-variant-id");
      if (summaryQty) summaryQty.textContent = label;
      if (summaryTotal) summaryTotal.textContent = price;
      if (stickyPrice) stickyPrice.textContent = price;
      if (hiddenVariant) hiddenVariant.value = variantId;
      if (hiddenLabel) hiddenLabel.value = label;
    }

    options.forEach(function (opt) {
      opt.addEventListener("click", function () {
        selectOption(opt);
        mtTrack("AddToCart", mtDatosProducto(opt));
      });
    });
    var preselected = root.querySelector("[data-mt-option][data-mt-default='true']") || options[0];
    if (preselected) {
      selectOption(preselected);
      /* Sin esto Meta no sabe qué producto está viendo la gente en la landing */
      mtTrack("ViewContent", mtDatosProducto(preselected));
    }

    /* Botones "Comprar ahora" desplazan a la sección de formulario */
    document.querySelectorAll("[data-mt-scroll-to-form]").forEach(function (btn) {
      btn.addEventListener("click", irAlPaso);
    });
  }

  /* ===== Hasta dónde baja la gente =====
     El 95% se va antes de tocar una opción de compra y no sabemos en qué
     parte. Esto lo manda a Meta como eventos propios para poder verlo en el
     administrador de eventos y recortar con datos, no a ojo. */
  function initProfundidad() {
    var hitos = [25, 50, 75, 90];
    var enviados = {};
    function medir() {
      var alto = document.documentElement.scrollHeight - window.innerHeight;
      if (alto <= 0) return;
      var pct = (window.scrollY / alto) * 100;
      hitos.forEach(function (h) {
        if (pct >= h && !enviados[h]) {
          enviados[h] = true;
          try {
            if (typeof window.fbq === "function") {
              window.fbq("trackCustom", "Scroll" + h, { pagina: window.MT_PAGE_TYPE || "" });
            }
          } catch (e) {}
        }
      });
    }
    window.addEventListener("scroll", medir, { passive: true });
  }

  /* Barra de progreso de lectura */
  function initBarraProgreso() {
    var barra = document.querySelector("[data-mt-progress]");
    if (!barra) return;
    function pintar() {
      var alto = document.documentElement.scrollHeight - window.innerHeight;
      var pct = alto > 0 ? (window.scrollY / alto) * 100 : 0;
      barra.style.width = Math.min(Math.max(pct, 0), 100) + "%";
    }
    pintar();
    window.addEventListener("scroll", pintar, { passive: true });
    window.addEventListener("resize", pintar, { passive: true });
  }

  /* Lleva al formulario, o reabre la pantalla de pago si hay un pedido pendiente */
  function irAlPaso() {
    var pantalla = document.querySelector("[data-mt-pay]");
    var pendiente = leerPedidoPendiente();
    if (pantalla && pendiente) {
      if (pantalla.hidden) mostrarPantallaPago(pantalla, pendiente, true);
      else abrirPantallaPago(pantalla);
      return;
    }
    var form = document.querySelector("[data-mt-checkout-form]");
    if (form) form.scrollIntoView({ behavior: "smooth", block: "start" });
  }

  /* Devuelve el pedido pendiente guardado (menos de 24 h) o null */
  function leerPedidoPendiente() {
    /* Con la pasarela no existe pantalla de pago propia: un pedido viejo
       guardado en el navegador no debe aparecer encima del flujo nuevo */
    if (mtPasarelaActiva()) return null;
    var guardado;
    try {
      guardado = JSON.parse(localStorage.getItem(MT_PAY_KEY) || "null");
    } catch (e) { return null; }
    if (!guardado || !guardado.ref) return null;
    var horas = (Date.now() - (guardado.creado || 0)) / 3600000;
    if (horas > 24) {
      try { localStorage.removeItem(MT_PAY_KEY); } catch (e) {}
      return null;
    }
    return guardado;
  }

  /* ===== Formulario de checkout: valida, agrega al carrito y redirige ===== */
  /* ===== Eventos para el pixel de Meta =====
     El cliente ya no pasa por el checkout de Shopify, así que los eventos
     los enviamos desde aquí. */
  function mtMontoNumerico(textoTotal) {
    if (!textoTotal) return 0;
    var limpio = textoTotal.replace(/[^\d.,]/g, "").replace(/\./g, "").replace(",", ".");
    var n = parseFloat(limpio);
    return isNaN(n) ? 0 : n;
  }

  function mtPasarelaActiva() {
    var f = document.querySelector("[data-mt-checkout-form]");
    return !!f && f.getAttribute("data-mt-pasarela") === "true";
  }

  /* Qué eventos manda ya el pixel de Shopify por su cuenta:
       - ViewContent: solo en plantillas de producto, no en la de inicio
       - InitiateCheckout y Purchase: desde el checkout, con datos reales
       - AddToCart: en este flujo no lo manda nadie, porque el pedido pasa por
         un enlace de carrito y no por el carrito con JavaScript
     Aquí solo llenamos los huecos: nunca duplicamos lo que Shopify ya envía. */
  function mtShopifyYaLoManda(evento) {
    if (evento === "ViewContent") return window.MT_PAGE_TYPE === "product";
    if (evento === "InitiateCheckout" || evento === "Purchase") return mtPasarelaActiva();
    return false;
  }

  /* El pixel de Meta carga de forma asíncrona: cuando esta página termina de
     armarse, fbq todavía puede no existir. Sin esta cola, los eventos que se
     disparan al abrir la página se perdían en silencio. */
  var mtCola = [];
  var mtReintento = null;

  function mtEnviar(evento, datos) {
    try {
      if (typeof window.fbq === "function") {
        window.fbq("track", evento, datos || {});
        return true;
      }
    } catch (e) {}
    return false;
  }

  function mtVaciarCola() {
    if (mtReintento) return;
    var intentos = 0;
    mtReintento = setInterval(function () {
      intentos++;
      if (typeof window.fbq === "function") {
        while (mtCola.length) {
          var pend = mtCola.shift();
          mtEnviar(pend[0], pend[1]);
        }
        clearInterval(mtReintento);
        mtReintento = null;
      } else if (intentos > 40) {
        /* Diez segundos sin pixel: no llegó, dejamos de insistir */
        clearInterval(mtReintento);
        mtReintento = null;
      }
    }, 250);
  }

  function mtTrack(evento, datos) {
    if (mtShopifyYaLoManda(evento)) return;
    if (mtEnviar(evento, datos)) return;
    mtCola.push([evento, datos]);
    mtVaciarCola();
  }

  /* Datos del producto con el formato que Meta usa para segmentar y para
     enlazar con el catálogo */
  function mtDatosProducto(opt) {
    if (!opt) return null;
    return {
      content_ids: [opt.getAttribute("data-mt-variant-id")],
      content_type: "product",
      content_name: opt.getAttribute("data-mt-label"),
      value: mtMontoNumerico(opt.getAttribute("data-mt-price-fmt")),
      currency: "CRC"
    };
  }

  /* ===== Pasarela de Shopify: códigos de provincia =====
     Shopify espera el CÓDIGO, no el nombre. Si se manda el nombre, el pedido
     se registra con la provincia equivocada. */
  var MT_COD_PROVINCIA = {
    "San José": "CR-SJ",
    "Alajuela": "CR-A",
    "Cartago": "CR-C",
    "Heredia": "CR-H",
    "Guanacaste": "CR-G",
    "Puntarenas": "CR-P",
    "Limón": "CR-L"
  };

  /* Arma el enlace al checkout de Shopify con todos los datos ya llenos */
  function urlCheckout(d, variantId) {
    var p = [];
    function add(clave, valor) {
      if (valor) p.push(clave + "=" + encodeURIComponent(valor));
    }
    add("checkout[email]", d.correo);
    add("checkout[shipping_address][first_name]", d.nombre);
    add("checkout[shipping_address][last_name]", d.apellido);
    add("checkout[shipping_address][phone]", d.whatsapp);
    add("checkout[shipping_address][address1]", d.direccion);
    add("checkout[shipping_address][address2]", d.distrito);
    add("checkout[shipping_address][city]", d.canton);
    add("checkout[shipping_address][province]", MT_COD_PROVINCIA[d.provincia] || "");
    add("checkout[shipping_address][country]", "Costa Rica");
    return "/cart/" + variantId + ":1?" + p.join("&");
  }

  /* ===== Pantalla de pago por SINPE ===== */
  var MT_PAY_KEY = "mt_pedido_pendiente";
  var mtPagoActivo = false;

  function abrirPantallaPago(pantalla) {
    pantalla.hidden = false;
    mtPagoActivo = true;
    document.body.classList.add("mt-pay-abierto");
    var dialogo = pantalla.querySelector(".mt-pay__dialog");
    if (dialogo) dialogo.scrollTop = 0;
    pantalla.scrollTop = 0;
  }

  function cerrarPantallaPago(pantalla) {
    pantalla.hidden = true;
    document.body.classList.remove("mt-pay-abierto");
  }

  function initCerrarPago() {
    var pantalla = document.querySelector("[data-mt-pay]");
    if (!pantalla) return;
    var btnCerrar = pantalla.querySelector("[data-mt-pay-close]");
    if (btnCerrar) {
      btnCerrar.addEventListener("click", function () { cerrarPantallaPago(pantalla); });
    }
    pantalla.addEventListener("click", function (e) {
      if (e.target === pantalla) cerrarPantallaPago(pantalla);
    });
    document.addEventListener("keydown", function (e) {
      if (e.key === "Escape" && !pantalla.hidden) cerrarPantallaPago(pantalla);
    });
  }

  function generarReferencia() {
    var n = Math.floor(Math.random() * 90000) + 10000;
    return "LUM-" + n;
  }

  function mostrarPantallaPago(pantalla, d, esRestaurada) {
    var waNumero = pantalla.getAttribute("data-mt-wa") || "50663226364";
    var sinpe = pantalla.getAttribute("data-mt-sinpe") || "";
    var minutos = parseInt(pantalla.getAttribute("data-mt-minutos") || "120", 10);

    if (!d.ref) d.ref = generarReferencia();
    if (!d.creado) d.creado = Date.now();

    var refEl = pantalla.querySelector("[data-mt-pay-ref]");
    if (refEl) refEl.textContent = d.ref;

    var titulo = pantalla.querySelector("[data-mt-pay-title]");
    if (titulo) titulo.textContent = "¡Ya casi, " + d.nombre + "!";

    var totalEl = pantalla.querySelector("[data-mt-pay-total]");
    if (totalEl) totalEl.textContent = d.total;

    /* Sin emojis: en varios teléfonos llegaban como cuadros rotos y el mensaje
       se veía poco profesional */
    var detalle =
      "Pedido: " + d.ref + "\n" +
      "Producto: " + d.producto + "\n" +
      "Cantidad: " + d.cantidad + "\n" +
      "Total: " + d.total + "\n" +
      "\n" +
      "Mis datos:\n" +
      "Nombre: " + d.nombre + " " + d.apellido + "\n" +
      "WhatsApp: " + d.whatsapp + "\n" +
      "Correo: " + d.correo + "\n" +
      "Direccion: " + d.provincia + ", " + d.canton + ", " + d.distrito + "\n" +
      "Senas: " + d.direccion + "\n" +
      "Envio: " + (d.mensajeria || "Envío a domicilio") + " (GRATIS)";

    var mensaje =
      "Hola, Lumina. Ya hice el SINPE Movil y les mando el comprobante.\n\n" +
      detalle + "\n\n" +
      "Aqui les adjunto la foto del comprobante.";

    var mensajeDuda =
      "Hola, Lumina. Sobre mi pedido " + d.ref + " (" + d.cantidad + " - " + d.total + ") tengo una duda antes de hacer el SINPE.";

    var monto = mtMontoNumerico(d.total);

    var btnWa = pantalla.querySelector("[data-mt-pay-wa]");
    if (btnWa) {
      btnWa.href = "https://wa.me/" + waNumero + "?text=" + encodeURIComponent(mensaje);
    }
    var btnDuda = pantalla.querySelector("[data-mt-pay-help]");
    if (btnDuda) btnDuda.href = "https://wa.me/" + waNumero + "?text=" + encodeURIComponent(mensajeDuda);

    /* Dos etapas: primero el SINPE, y solo después se abre WhatsApp.
       Antes el chat se abría de una y el cliente se iba de la página sin pagar. */
    var etapaPago = pantalla.querySelector("[data-mt-etapa-pago]");
    var etapaEnvio = pantalla.querySelector("[data-mt-etapa-envio]");
    var btnHecho = pantalla.querySelector("[data-mt-pay-done]");

    function pintarEtapa(pagado) {
      if (etapaPago) etapaPago.hidden = !!pagado;
      if (etapaEnvio) etapaEnvio.hidden = !pagado;
      pantalla.classList.toggle("mt-pay--comprobante", !!pagado);
      var titulo2 = pantalla.querySelector("[data-mt-pay-title]");
      if (titulo2 && pagado) titulo2.textContent = "Último paso, " + d.nombre;
      var lead = pantalla.querySelector("[data-mt-pay-lead]");
      if (lead && pagado) {
        lead.textContent = "Ya solo falta que nos mandés la foto del comprobante para verificar tu pago y despachar tu paquete.";
      }
    }

    if (btnHecho && !btnHecho.dataset.mtReady) {
      btnHecho.dataset.mtReady = "1";
      btnHecho.addEventListener("click", function () {
        d.pagado = true;
        try { localStorage.setItem(MT_PAY_KEY, JSON.stringify(d)); } catch (e) {}
        pintarEtapa(true);
        /* El cliente declara que ya hizo el SINPE: es la señal más cercana
           a una compra que podemos capturar en la web */
        mtTrack("Purchase", {
          value: monto,
          currency: "CRC",
          content_name: d.producto,
          contents: [{ id: d.ref, quantity: 1 }]
        });
        if (etapaEnvio) etapaEnvio.scrollIntoView({ behavior: "smooth", block: "center" });
      });
    }

    pintarEtapa(d.pagado === true);

    /* Botones de copiar */
    pantalla.querySelectorAll("[data-mt-copy]").forEach(function (btn) {
      if (btn.dataset.mtCopyReady) return;
      btn.dataset.mtCopyReady = "1";
      btn.addEventListener("click", function () {
        var que = btn.getAttribute("data-mt-copy");
        /* Se copian solo los dígitos: los guiones son para leer, no para pegar */
        var texto = (que === "sinpe" ? sinpe : d.total).replace(/[^\d]/g, "");
        var original = btn.textContent;
        function ok() {
          btn.textContent = "¡Copiado!";
          btn.classList.add("mt-pay__copy--ok");
          setTimeout(function () {
            btn.textContent = original;
            btn.classList.remove("mt-pay__copy--ok");
          }, 1800);
        }
        if (navigator.clipboard && navigator.clipboard.writeText) {
          navigator.clipboard.writeText(texto).then(ok).catch(function () { copiaManual(texto, ok); });
        } else {
          copiaManual(texto, ok);
        }
      });
    });

    /* Contador de reserva */
    var timerEl = pantalla.querySelector("[data-mt-pay-timer]");
    if (timerEl) {
      var restante = minutos * 60;
      var pintar = function () {
        var h = Math.floor(restante / 3600);
        var m = Math.floor((restante % 3600) / 60);
        var s = restante % 60;
        var dosDig = function (n) { return n < 10 ? "0" + n : "" + n; };
        timerEl.textContent = (h > 0 ? h + ":" : "") + dosDig(m) + ":" + dosDig(s);
        if (restante > 0) restante--;
      };
      pintar();
      setInterval(pintar, 1000);
    }

    abrirPantallaPago(pantalla);

    /* Guarda el pedido por si el cliente cierra la página */
    try {
      localStorage.setItem(MT_PAY_KEY, JSON.stringify(d));
    } catch (e) {}

    /* Nada de abrir WhatsApp solo: el cliente se iba del sitio antes de ver
       el número de SINPE y el pedido se quedaba sin pagar */
  }

  /* Si el cliente vuelve y tenía un pedido sin pagar, se lo mostramos otra vez */
  function initPagoPendiente() {
    var pantalla = document.querySelector("[data-mt-pay]");
    if (!pantalla) return;
    var guardado = leerPedidoPendiente();
    if (!guardado) return;
    mostrarPantallaPago(pantalla, guardado, true);
  }

  function copiaManual(texto, alTerminar) {
    var tmp = document.createElement("textarea");
    tmp.value = texto;
    tmp.setAttribute("readonly", "");
    tmp.style.position = "absolute";
    tmp.style.left = "-9999px";
    document.body.appendChild(tmp);
    tmp.select();
    try { document.execCommand("copy"); alTerminar(); } catch (e) {}
    document.body.removeChild(tmp);
  }

  function initCheckoutForm() {
    var form = document.querySelector("[data-mt-checkout-form]");
    if (!form) return;
    var submitBtn = form.querySelector("[data-mt-submit]");
    var errorBox = form.querySelector("[data-mt-form-error]");
    var requiredFieldNames = ["nombre", "apellido", "whatsapp", "correo", "provincia", "canton", "distrito", "direccion"];

    function formIsComplete() {
      var variantId = form.querySelector("[data-mt-selected-variant]").value;
      if (!variantId) return false;
      return requiredFieldNames.every(function (name) {
        var field = form.querySelector("[name='" + name + "']");
        return field && field.value.trim() !== "";
      });
    }

    var hint = form.querySelector("[data-mt-form-hint]");
    function updateSubmitState() {
      if (!submitBtn) return;
      var completo = formIsComplete();
      submitBtn.disabled = !completo;
      if (hint) hint.hidden = completo;
    }

    /* Muestra la mensajería elegida en el resumen del pedido */
    var resumenShip = document.querySelector("[data-mt-summary-ship]");
    function mensajeriaElegida() {
      var sel = form.querySelector("[name='mensajeria']:checked");
      return sel ? sel.value : "";
    }
    function pintarMensajeria() {
      if (resumenShip) resumenShip.textContent = mensajeriaElegida() || "—";
    }
    pintarMensajeria();

    updateSubmitState();
    form.addEventListener("input", updateSubmitState);
    form.addEventListener("change", function () {
      updateSubmitState();
      pintarMensajeria();
    });

    form.addEventListener("submit", function (e) {
      e.preventDefault();
      if (errorBox) { errorBox.textContent = ""; errorBox.style.display = "none"; }

      var variantId = form.querySelector("[data-mt-selected-variant]").value;
      var nombre = form.querySelector("[name='nombre']").value.trim();
      var apellido = form.querySelector("[name='apellido']").value.trim();
      var whatsapp = form.querySelector("[name='whatsapp']").value.trim();
      var correo = form.querySelector("[name='correo']").value.trim();
      var provincia = form.querySelector("[name='provincia']").value;
      var canton = form.querySelector("[name='canton']").value;
      var distrito = form.querySelector("[name='distrito']").value;
      var direccion = form.querySelector("[name='direccion']").value.trim();

      if (!variantId || !nombre || !apellido || !whatsapp || !correo || !provincia || !canton || !distrito || !direccion) {
        if (errorBox) {
          errorBox.textContent = "Por favor completa todos los campos antes de continuar.";
          errorBox.style.display = "block";
          errorBox.scrollIntoView({ behavior: "smooth", block: "center" });
        }
        return;
      }

      if (!/^[^\s@]+@[^\s@]+\.[^\s@]+$/.test(correo)) {
        if (errorBox) {
          errorBox.textContent = "Revisa tu correo electrónico, parece que tiene un error.";
          errorBox.style.display = "block";
          errorBox.scrollIntoView({ behavior: "smooth", block: "center" });
        }
        return;
      }

      if (submitBtn) { submitBtn.disabled = true; submitBtn.textContent = "Procesando..."; }

      var pantalla = document.querySelector("[data-mt-pay]");
      var labelInput = form.querySelector("[data-mt-selected-label]");
      var cantidad = labelInput ? labelInput.value : "";
      var totalEl = document.querySelector("[data-mt-summary-total]");
      var total = totalEl ? totalEl.textContent.trim() : "";
      var producto = "GlorySmile V34 - Tiras Blanqueadoras Moradas";
      var labelProducto = document.querySelector("[data-mt-product-label]");
      if (labelProducto) producto = labelProducto.textContent.trim();

      var datos = {
        nombre: nombre, apellido: apellido, whatsapp: whatsapp, correo: correo,
        provincia: provincia, canton: canton, distrito: distrito, direccion: direccion,
        producto: producto, cantidad: cantidad, total: total, mensajeria: mensajeriaElegida()
      };

      /* Modo pasarela: el pedido se crea de verdad en Shopify. El cliente llega
         al checkout con todo lleno y solo elige SINPE Móvil. */
      if (form.getAttribute("data-mt-pasarela") === "true") {
        mtTrack("InitiateCheckout", {
          value: mtMontoNumerico(total),
          currency: "CRC",
          content_name: producto,
          num_items: 1
        });
        /* Estos datos quedan escritos en el pedido para que la entrega se pueda
           coordinar sin abrir la página. Van en el orden en que se leen al
           despachar. Son solo información: no intervienen en el cobro. */
        var extras = [
          ["Provincia", provincia],
          ["Cantón", canton],
          ["Distrito", distrito],
          ["Dirección exacta", direccion],
          ["WhatsApp", whatsapp]
        ];
        var destino = urlCheckout(datos, variantId);
        extras.forEach(function (par) {
          if (!par[1]) return;
          destino += "&attributes[" + encodeURIComponent(par[0]) + "]=" + encodeURIComponent(par[1]);
        });
        window.location.href = destino;
        return;
      }

      /* Guarda el pedido en el carrito como respaldo; no bloquea la pantalla de pago */
      fetch("/cart/add.js", {
        method: "POST",
        headers: { "Content-Type": "application/json" },
        body: JSON.stringify({
          items: [
            {
              id: parseInt(variantId, 10),
              quantity: 1,
              properties: {
                Nombre: nombre,
                Apellido: apellido,
                WhatsApp: whatsapp,
                "Correo": correo,
                Provincia: provincia,
                "Cantón": canton,
                Distrito: distrito,
                "Dirección exacta": direccion,
                "Mensajería": mensajeriaElegida()
              }
            }
          ]
        })
      }).catch(function () {});

      /* Meta: el cliente completó sus datos y llegó a la pantalla de pago */
      mtTrack("InitiateCheckout", {
        value: mtMontoNumerico(total),
        currency: "CRC",
        content_name: producto,
        num_items: 1
      });

      if (pantalla) {
        mostrarPantallaPago(pantalla, datos);
        if (submitBtn) { submitBtn.disabled = false; submitBtn.textContent = "Confirmar pedido"; }
        return;
      }

      Promise.resolve()
        .catch(function () {
          if (errorBox) {
            errorBox.textContent = "Hubo un problema al procesar tu pedido. Por favor intenta de nuevo.";
            errorBox.style.display = "block";
          }
          if (submitBtn) { submitBtn.disabled = false; submitBtn.textContent = "Confirmar pedido"; }
        });
    });
  }

  /* ===== CTA fijo: aparece tras pasar el inicio, se oculta sobre el formulario ===== */
  function initStickyCta() {
    var sticky = document.querySelector("[data-mt-sticky-cta]");
    var hero = document.querySelector("[data-mt-hero]");
    var checkoutForm = document.querySelector("[data-mt-checkout-form]");
    if (!sticky || !hero) return;

    var pantallaPago = document.querySelector("[data-mt-pay]");
    var stickyTexto = sticky.querySelector("[data-mt-scroll-to-form]");
    var textoOriginal = stickyTexto ? stickyTexto.textContent : "";

    function evaluate() {
      var heroRect = hero.getBoundingClientRect();
      var heroPassed = heroRect.bottom <= 0;

      /* Si ya hay un pedido esperando pago, el botón lleva a completarlo */
      var pagoActivo = pantallaPago && !!leerPedidoPendiente();
      if (stickyTexto) {
        stickyTexto.textContent = pagoActivo ? "Completar mi pago" : textoOriginal;
      }
      /* Con pedido pendiente el botón siempre acompaña; si no, se esconde
         cuando el formulario ya está a la vista */
      var formVisible = false;
      if (!pagoActivo && checkoutForm) {
        var formRect = checkoutForm.getBoundingClientRect();
        formVisible = formRect.top < window.innerHeight * 0.8 && formRect.bottom > 0;
      }
      var modalAbierto = pantallaPago && !pantallaPago.hidden;
      sticky.classList.toggle("mt-sticky-cta--visible", heroPassed && !formVisible && !modalAbierto);
    }
    /* Antes esto medía tres elementos en CADA píxel de scroll y trababa el
       desplazamiento en celular. Ahora se mide una vez por cuadro de video. */
    var pendiente = false;
    function alDesplazar() {
      if (pendiente) return;
      pendiente = true;
      requestAnimationFrame(function () {
        pendiente = false;
        evaluate();
      });
    }

    evaluate();
    window.addEventListener("scroll", alDesplazar, { passive: true });
    window.addEventListener("resize", alDesplazar, { passive: true });
    window.addEventListener("orientationchange", alDesplazar, { passive: true });
    /* Red de seguridad: si el navegador no emite scroll (pasa en algunos
       casos con desplazamiento por inercia), igual se revisa cada segundo */
    setInterval(evaluate, 1000);

    var stickyBtn = sticky.querySelector("[data-mt-scroll-to-form]");
    if (stickyBtn) stickyBtn.addEventListener("click", irAlPaso);
  }

  document.addEventListener("DOMContentLoaded", function () {
    /* El botón de comprar va PRIMERO y cada arranque va aislado: antes iba de
       último y sin protección, así que un error en cualquier otra parte de la
       página dejaba al cliente sin botón de compra y nadie se enteraba. */
    [
      initStickyCta,
      initPurchaseFlow,
      initCheckoutForm,
      initCrLocation,
      initReveal,
      initFaq,
      initTestimonialCarousel,
      initBeforeAfter,
      initCountUp,
      initGallery,
      initWhatsapp,
      initCobertura,
      initCerrarPago,
      initPagoPendiente,
      initBarraProgreso,
      initProfundidad
    ].forEach(function (arrancar) {
      try { arrancar(); } catch (e) {}
    });
  });
})();
